import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useIntl } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons/index.tsx';
import { iconUsers } from '@sorare/core/src/atoms/icons/system/iconUsers.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex/index.tsx';
import { LabelS } from '@sorare/core/src/atoms/typography/index.tsx';
import { WidgetChip } from '@sorare/core/src/atoms/ui/Chip/WidgetChip/index.tsx';
import { WidgetButton } from '@sorare/core/src/atoms/ui/WidgetButton/index.tsx';
import { ANY_SPORT_SERIES_SQUAD } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary.ts';

import squadImg from '#src/assets/squad.webp';

import type { SquadEntryBadge_squad } from './__generated__/index.graphql.ts';

type Props = {
  squad: Nullable<SquadEntryBadge_squad>;
};

export const SquadEntryBadge = ({ squad }: Props) => {
  const { generateSportContextPath } = useSportContext();
  const { formatMessage } = useIntl();

  return (
    <WidgetButton
      to={generateSportContextPath(ANY_SPORT_SERIES_SQUAD)}
      chip={
        squad ? (
          <WidgetChip>
            <Horizontal gap={0.5}>
              <FontAwesomeIcon icon={iconUsers} />
              <LabelS bold>{squad.membersCount}</LabelS>
            </Horizontal>
          </WidgetChip>
        ) : (
          <WidgetChip state="new" />
        )
      }
    >
      <img width={40} src={squadImg} alt={formatMessage(glossary.squads)} />
    </WidgetButton>
  );
};

SquadEntryBadge.fragments = {
  squad: gql`
    fragment SquadEntryBadge_squad on Squad {
      id
      membersCount
    }
  ` as TypedDocumentNode<SquadEntryBadge_squad>,
};
